<template>
  <div>
    <div class="header clearfix">
      <div class="header-wrapper container-fluid">
        <router-link tag="div" to="/" class="logo pull-left">
          <img src="@/assets/images/logo.png" alt="云蜂树智" />
        </router-link>
        <div class="nav-btn pull-right" @click="toggleVisible">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </div>
      </div>
    </div>
    <div class="popUp" v-if="visible">
      <ul @click="toggleVisible">
          <li v-for="(item) in navigation" :key="item.name">
            <router-link class="realLink" :to="item.path" v-if="item.path">{{item.name}}
              <template v-if="item.children && item.children.length"></template>
            </router-link>
            <a href="javascript:void(0);" v-else>
              <template v-if="item.children && item.children.length">{{item.name}}</template>
            </a>
            <div class="children" v-if="item.children && item.children.length">
              <template v-for="(childItem, childIndex) in item.children" :key="childIndex">
                <router-link
                  :to="childItem.path"
                  v-if="childItem.path"
                >{{childItem.name}}</router-link>
                <a href="javascript:void(0);" v-else>
                  <template v-if="item.children && item.children.length">{{childItem.name}} </template>
                </a>
              </template>
            </div>
          </li>
        </ul>
    </div>
    <div class="mask" v-if="visible" @click="toggleVisible"></div>
  </div>
</template>

<script>
import { navigation } from '@/core/dataCommon';

export default {
  name: 'Header',
  props: {},
  data() {
    return {
      navigation,
      visible: false
    };
  },
  mounted() {
    this.navigation = this.navigation.slice(1);
  },
  methods: {
    toggleVisible() {
      this.visible = !this.visible;
    }
  },
};
</script>

<style scoped lang="scss">
.header{
  height: 50px;
  box-sizing: border-box;
  .header-wrapper{
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 9;
    background-color: #fff;
    border-bottom: 1px solid #e4e4e4;
  }
}
.logo{
  margin-top: 10px;
  img{
    width: 125px;
  }
}
.nav-btn{
  float: right;
  padding: 9px 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  border-radius: 4px;
  border: 1px solid $color-primary;
  .icon-bar{
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px;
    background-color: $color-primary;
    & + .icon-bar{
      margin-top: 4px;
    }
  }
}
.popUp{
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  z-index: 99;
  background: #fff;
  padding-bottom: 12px;
  ul{
    li{
      padding: 0 30px;
      & > a{
        display: block;
        font-size: 12px;
        margin-top: 12px;
        &.realLink{
          font-size: 14px;
          line-height: 26px;
          font-weight: bold;
        }
      }
      .children{
        margin-top: 8px;
        a{
          display: block;
          font-size: 14px;
          font-weight: bold;
          line-height: 26px;
        }
      }
      a.router-link-exact-active{
        color: $color-primary;
      }
    }
  }
}
.mask{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 8;
  background-color: rgba(0,0,0,.3);
}

</style>
